.stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.banner {
  background: var(--bg-accent-tint);
  border: 1px solid var(--border-4);
  border-radius: var(--r-10);
  padding: 12px 14px;
  font-size: 14px;
  color: var(--text-secondary);
}

.critical {
  background: #fdecea;
  border-color: #f2b8b5;
  color: #7a1f1a;
}
